import { getDictionaryFromCms } from 'application/adapters/cms/dictionaryAdapter';
import { get } from 'env-var';

let NODE_ENV: string;

// Only perform assignment and check serverside / at build time
if (typeof window === 'undefined') {
	// Read variables using env-var API
	// eslint-disable-next-line prefer-const -- assigned conditionally, can't be const
	NODE_ENV = get('NODE_ENV').required().asString();
}

export interface Replacement {
	name: string;
	value: string;
}

export interface DictionaryInterface {
	getValue(key: string, replacements?: Replacement[], defaultValue?: string): string;
	items: Content.DictionaryItem[];
	culture: string;
}

export const DictionaryFactory = (items: Content.DictionaryItem[], culture: string): DictionaryInterface => {
	return {
		getValue(key: string, replacements?: Replacement[], defaultValue?: string): string {
			const dictionaryValue: Content.DictionaryItem = items.find((element) => element?.key.toLocaleLowerCase() === key.toLocaleLowerCase());
			let dictionaryString = dictionaryValue?.values?.find(
				(element) => element?.culture.toLocaleLowerCase() === culture.toLocaleLowerCase(),
			)?.value;

			if (!dictionaryString) {
				if (!defaultValue) {
					//Cannot find dictionary text and no default supplied - in development we use a default error text
					return NODE_ENV === 'development' ? `[DICTIONARY ${key} MISSING FOR ${culture}]` : key;
				} else {
					return (dictionaryString = defaultValue);
				}
			}

			if (!replacements) {
				return dictionaryString;
			}

			replacements.forEach((replacement) => {
				return (dictionaryString = dictionaryString.replace('${' + replacement.name + '}', replacement.value));
			});

			return dictionaryString;
		},
		items: items,
		culture: culture as string,
	};
};

export interface getDictionaryItemsProps {
	preview?: boolean;
	previewData?: Content.PreviewData;
}
export const getDictionaryItems = async ({ preview, previewData }: getDictionaryItemsProps): Promise<Content.DictionaryItem[]> => {
	return await getDictionaryFromCms(preview, previewData);
};
